import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { isAllFilesPage } from '../../helpers/Files';
import { isMiniAdobeIntegration } from '../../helpers/App';
import { sendAdobePostMessage } from '../../helpers/Adobe';

const MiniEmptyCollection = ({ profile, allCollections, selectedFilters }) => {
  const handleLink = (link) => {
    if (isMiniAdobeIntegration()) {
      sendAdobePostMessage('open-link', link);
    }
  };

  if (allCollections) {
    return (
      <div className="nothing-found-wrapper">
        <i className="far fa-layer-group fa-3x" />
        <h4>No Collections!</h4>
        <p>Collections help organize your files, just like folders.</p>
      </div>
    );
  }

  if (isAllFilesPage() && Object.keys(selectedFilters).length === 0) {
    return (
      <div className="nothing-found-wrapper">
        <i className="far fa-file fa-3x" />
        <h4>Make sure you add some files to Stockpress!</h4>
        <p className="m-4">
          <Button
            tag="a"
            href={`https://${profile.client.domain}`}
            target="_blank"
            onClick={() => handleLink(`https://${profile.client.domain}`)}
          >
            Go to my workspace
          </Button>
        </p>
        <p>
          <a
            href="https://help.stockpress.co"
            target="_blank"
            rel="noreferrer"
            onClick={() => handleLink('https://help.stockpress.co')}
          >
            Need help? See how here.
          </a>
        </p>
      </div>
    );
  }

  if (isAllFilesPage() && Object.keys(selectedFilters).length > 0) {
    return (
      <div className="nothing-found-wrapper">
        <h4>Sorry, no results found</h4>
      </div>
    );
  }

  return (
    <div className="nothing-found-wrapper">
      <i className="far fa-layer-group fa-3x" />
      <h4>No files in this Collection</h4>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  selectedFilters: state.Files.filters,
});

MiniEmptyCollection.propTypes = {
  profile: PropTypes.object,
  allCollections: PropTypes.bool,
  selectedFilters: PropTypes.object.isRequired,
};

MiniEmptyCollection.defaultProps = {
  profile: null,
  allCollections: false,
};

export default connect(mapStateToProps)(MiniEmptyCollection);
